import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { API_BASE_PATH } from '../../../constants';
import { getProfileOwner } from '../../selectors/users';

function fetchFromApi(params) {
  return axios
    .get(`${API_BASE_PATH}/module/my_comments`, { params })
    .catch(response => false);
}

export default function* fetchMoreMyComments(action) {
  const { streamId } = action;

  const [offset, limit, streamParams, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
    select(getProfileOwner),
  ]);

  const queryParams = {
    moduleid: streamParams.moduleId,
    username: profileOwner.user.username,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response && response.status === 200) {
    const { hasMore, nextOffset, results } = response.data;

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: results,
      })
    );
  }

  // TODO error catching
}
